import React from 'react';
import './LogosGallery.scss';

import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

const LogosGallery = ({logosGallery}) => {

  const responsive = {
    0: { items: 2 },
    768: { items: 4 },
    1200: {items: 5}
  };

  const logos = logosGallery.map(logo => (
    <img src={`${process.env.REACT_APP_API_URL}${logo.path}`} alt=""/>
  ));

  return (
    <section className="homepage-logos-section">
      <h3 className="homepage-logos__title">Trusted by over 3K sites</h3>
      <AliceCarousel
        autoPlay={true}
        autoPlayInterval={3000}
        buttonsDisabled={true}
        responsive={responsive}
        items={logos}/>
    </section>
  );
};

export default LogosGallery;